// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "cart-1wofZ";
export { _1 as "__esModule", _2 as "cart" }
export default { "__esModule": _1, "cart": _2 }
